"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.6.6C8.14.6 6.94 1.67 6.72 3.07c-1.4.22-2.47 1.42-2.47 2.88 0 .08.01.15.02.23h-.3v1h6.41v-1h-.3c0-.08.02-.15.02-.23 0-1.42-1.02-2.61-2.37-2.87.2-.85.96-1.48 1.87-1.48 1.06 0 1.93.86 1.93 1.93v11.91h1V3.53C12.53 1.92 11.22.6 9.6.6Zm-.5 5.35c0 .08-.03.15-.03.23H5.29c0-.08-.03-.15-.03-.23a1.931 1.931 0 0 1 3.86 0H9.1Zm-2.47 2.6h1v4.68h-1V8.55Zm-1.77-.77h1v4.68h-1V7.78Zm3.55 0h1v4.68h-1V7.78Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.407.765a4.214 4.214 0 0 0-4.177 3.69 4.22 4.22 0 0 0-3.69 4.178c0 .18.015.352.037.532h-.652v1.125h9.652V9.165h-.652a4.14 4.14 0 0 0 .037-.532 4.224 4.224 0 0 0-3.6-4.17 3.087 3.087 0 0 1 3.038-2.58 3.095 3.095 0 0 1 3.09 3.09v17.954h1.125V4.98A4.219 4.219 0 0 0 14.4.765h.007Zm-.562 7.875c0 .18-.023.353-.053.533H7.71a3.125 3.125 0 0 1-.053-.533 3.095 3.095 0 0 1 3.09-3.09 3.095 3.095 0 0 1 3.09 3.09h.008Zm-3.72 3.915h1.125v7.058h-1.125v-7.058Zm-2.67-1.162H8.58v7.057H7.455v-7.057Zm5.347 0h1.125v7.057h-1.125v-7.057Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.21 1.02c-2.86 0-5.23 2.15-5.57 4.92-2.77.35-4.92 2.71-4.92 5.57 0 .24.02.47.05.71H7.9v1.5h12.87v-1.5h-.87c.03-.23.05-.47.05-.71 0-2.82-2.09-5.16-4.8-5.56.33-1.95 2.01-3.44 4.05-3.44 2.27 0 4.12 1.85 4.12 4.12v23.94h1.5V6.64c0-3.1-2.52-5.62-5.62-5.62h.01Zm-.75 10.5c0 .24-.03.47-.07.71h-8.11c-.04-.23-.07-.47-.07-.71 0-2.27 1.85-4.12 4.12-4.12s4.12 1.85 4.12 4.12h.01Zm-4.96 5.22H15v9.41h-1.5v-9.41Zm-3.56-1.55h1.5v9.41h-1.5v-9.41Zm7.13 0h1.5v9.41h-1.5v-9.41Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.875 1.508c-4.238 0-7.74 3.217-8.183 7.342-4.125.443-7.342 3.945-7.342 8.182 0 .42.03.833.09 1.245h-1.5v1.875h19.267v-1.875h-1.5c.06-.412.09-.825.09-1.245 0-4.2-3.165-7.664-7.23-8.167.427-3.09 3.082-5.482 6.293-5.482a6.36 6.36 0 0 1 6.352 6.352v35.82h1.875V9.743c0-4.538-3.69-8.228-8.228-8.228l.015-.007Zm-.938 15.524c0 .42-.053.833-.135 1.245H15.367a6.266 6.266 0 0 1-.135-1.245c0-3.502 2.85-6.36 6.352-6.36 3.503 0 6.36 2.85 6.36 6.36h-.007Zm-7.418 7.808h1.876v14.085H20.52V24.84Zm-5.332-2.317h1.875v14.085h-1.875V22.523Zm10.673 0h1.875v14.085H25.86V22.523Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    d: "M38.5 2.01c-5.65 0-10.32 4.29-10.91 9.79-5.5.59-9.79 5.26-9.79 10.91 0 .56.04 1.11.12 1.66h-2v2.5h25.69v-2.5h-2c.08-.55.12-1.1.12-1.66 0-5.6-4.22-10.22-9.64-10.89.57-4.12 4.11-7.31 8.39-7.31 4.67 0 8.47 3.8 8.47 8.47v47.76h2.5V12.99c0-6.05-4.92-10.97-10.97-10.97l.02-.01Zm-1.25 20.7c0 .56-.07 1.11-.18 1.66H20.49c-.11-.54-.18-1.1-.18-1.66 0-4.67 3.8-8.48 8.47-8.48 4.67 0 8.48 3.8 8.48 8.48h-.01Zm-9.89 10.41h2.5V51.9h-2.5V33.12Zm-7.11-3.09h2.5v18.78h-2.5V30.03Zm14.23 0h2.5v18.78h-2.5V30.03Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconBathroom = function IconBathroom(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Bathroom' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Bathroom"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconBathroom.sizes = [16, 24, 32, 48, 64];
IconBathroom.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconBathroom;
exports.default = _default;